<template>
  <div class="supervisor-content">
    <!--翻页按钮-->
    <div
      class="previous-page page-button"
      :class="{ 'on-show': showPageHan }"
      @mouseover="showPageHan = !showPageHan"
      @click="$emit('onPreviousClick')"
      @mouseout="showPageHan = !showPageHan"
    >
      <div class="in"><LeftOutlined /></div>
    </div>
    <div
      class="next-page page-button"
      :class="{ 'on-show': showPageHanNext }"
      @mouseover="showPageHanNext = !showPageHanNext"
      @click="$emit('onNextClick')"
      @mouseout="showPageHanNext = !showPageHanNext"
    >
      <div class="in"><RightOutlined /></div>
    </div>
    <!--end 翻页按钮-->
    <div class="dash-row row">
      <div
        class="col"
        v-for="item in JSON.parse(cItems)"
        :key="item.id"
        :class="{
          'buffer-area': item.type != 'AS',
          'fifo-area': item.type == 'fifo',
          'has-icon-left':
            item.leftIconType != undefined && item.leftIconType != 0,
          'has-icon-right':
            item.rightIconType != undefined && item.rightIconType != 0,
          'has-icon-left-hr': item.leftIconType == 7,
          'has-icon-right-hr': item.rightIconType == 7,
        }"
      >
        <div v-if="item.type == 'AS'">
          <div class="l-box">
            <div
              class="left-icon-box iconfont"
              :class="iconMap[item.leftIconType]"
            ></div>
            <div
              class="kanban"
              :class="{
                green: item.state == 'Green',
                danger: item.state == 'Red',
                grey: item.state == 'Grey',
                'border-green': item.state == 'BorderGreen',
                default: item.state == 'Default',
              }"
              @click="goKanbanPage(item)"
            >
              <div class="in-box">
                <h4 :class="{ 'text-left': item.progress }">{{ item.id }}</h4>
                <ec-dashboard
                  v-if="item.progress != null"
                  :data="item.progress"
                ></ec-dashboard>
              </div>
              <div class="work-order">{{ item.currentWorkOrder }}</div>
              <div
                class="andon"
                :class="{
                  warning: item.andonState == 'Yellow',
                  danger: item.andonState == 'Red',
                }"
              >
                <div
                  class="deng -px"
                  @click="openAndonDetailModal($event, item)"
                >
                  <i></i>
                  <i></i>
                  <i></i>
                </div>
              </div>
            </div>
            <div
              class="right-icon-box iconfont"
              :class="iconMap[item.rightIconType]"
            ></div>
          </div>
          <div class="kb-list-box row">
            <div v-for="(val, key) in item.feed" :key="key">
              <ul class="col s-kanban-list" v-if="item.state !== 'Default'">
                <li
                  v-for="sList in feedSplice(val, maxBomNum)"
                  :key="sList.id"
                  :class="{
                    warning: sList.state == 'Yellow',
                    danger: sList.state == 'Red',
                    grey: sList.state == 'Grey',
                    'is-triangle': key == 'fIFOLane',
                    'is-circle': key == 'sub',
                  }"
                >
                  <a-tooltip>
                    <template #title>{{ sList.id }}</template>
                    <i>{{ showCart(sList.id) }}</i>
                  </a-tooltip>
                </li>
              </ul>
            </div>

            <div
              class="button bom-more-btn"
              @click="openBomModal(item)"
              v-if="isShowBomMore(item.feed)"
            >
              <CaretDownOutlined />
            </div>
          </div>
        </div>
        <div class="st" v-if="item.type == 'ST'">
          <div
            class="left-icon-box iconfont"
            :class="iconMap[item.leftIconType]"
          ></div>
          <div
            class="big-triangle f-l"
            :class="{
              danger: item.triangleState == 'Red',
              warning: item.triangleState == 'Orange',
              green: item.triangleState == 'Green',
            }"
          >
            <a class="staging-link" @click="goStaging(item.regionCode)"></a>
            <div
              class="andon"
              @click="openAndonDetailModal($event, item)"
              :class="{
                green: item.andonState == 'Green',
                danger: item.andonState == 'Red',
                warning: item.andonState == 'Orange',
              }"
            >
              <div class="deng -px">
                <i></i>
                <i></i>
                <i></i>
              </div>
            </div>
            <span class="num">{{ item.count }}</span>
            <div class="txt">SWIP {{ item.swip }}</div>
          </div>
          <div
            class="right-icon-box iconfont"
            :class="iconMap[item.rightIconType]"
          ></div>
        </div>
      </div>
    </div>
    <a-modal
      v-model:visible="sAndonModal"
      title="Andon"
      width="80%"
      wrap-class-name="has-table-full-modal"
      @cancel="sAndonModal = false"
      :footer="null"
    >
      <a-table
        :loading="loading"
        size="middle"
        :dataSource="andonItem"
        :columns="columns"
        rowKey="id"
        :rowClassName="
          (record, index) => (index % 2 === 1 ? 'table-striped' : null)
        "
      >
        <template #bodyCell="{ column, record }">
          <template v-if="column.dataIndex === 'stopWs'">
            <WarningFilled
              v-if="record.stopWS"
              style="
                 {
                  font-size: 22px;
                  color: red;
                }
              "
            />
            <span v-else>-</span>
          </template>
        </template>
      </a-table>
    </a-modal>
    <a-modal
      v-model:visible="moreModal"
      wrap-class-name="has-table-full-modal bom-header"
      @cancel="sAndonModal = false"
      :footer="null"
    >
      <template #title>
        <div class="title-no-pd" :class="bomItems.state">
          <div class="title">{{ bomItems.id }}</div>
          <div class="sub-title">{{ bomItems.currentWorkOrder }}</div>
        </div>
      </template>
      <div class="sub-title-c"></div>
      <div class="has-bom-header">
        <div class="kb-list-box row" v-if="bomItems.state !== 'Default'">
          <ul
            class="s-kanban-list"
            v-for="(feedItem, key) in bomItems.feed"
            :key="key"
          >
            <li
              v-for="sList in feedItem"
              :key="sList.id"
              :class="{
                warning: sList.state == 'Yellow',
                danger: sList.state == 'Red',
                grey: sList.state == 'Grey',
                'is-triangle': key == 'fIFOLane',
                'is-circle': key == 'sub',
              }"
            >
              <a-tooltip>
                <template #title>{{ sList.id }}</template>
                <i>{{ limitTo(sList.id, -3) }}</i>
              </a-tooltip>
            </li>
          </ul>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
  import ecDashboard from './ec-dashboard.vue'
  import {
    LeftOutlined,
    RightOutlined,
    CaretDownOutlined,
    WarningFilled,
  } from '@ant-design/icons-vue'
  import { parseTime } from '@/utils'
  import { andonsummaryByRegion } from '@/api/supervisor-landing'
  export default {
    components: {
      ecDashboard,
      LeftOutlined,
      RightOutlined,
      CaretDownOutlined,
      WarningFilled,
    },
    props: {
      cItems: {
        type: String,
        default: '',
      },
      maxBomNum: {
        type: Number,
        default: 5,
      },
    },
    data() {
      return {
        moreModal: false,
        bomItems: {},
        iconMap: [
          'no-icon',
          'icon-jiantou',
          'icon-jiantou  reverse-icon',
          'icon-pull',
          'icon-dengyuhao',
          'icon-right-double',
          'icon-right-double reverse-icon',
        ],
        showPageHan: false,
        showPageHanNext: false,
        sAndonModal: false,
        loading: false,
        columns: [
          {
            title: 'No',
            dataIndex: 'no',
            customRender({ index }) {
              return index + 1
            },
            width: 60,
          },
          {
            title: 'Category',
            dataIndex: 'category',
            minWidth: 100,
          },
          {
            title: 'Andon Description',
            dataIndex: 'description',
            minWidth: 100,
          },
          {
            title: 'Job ID',
            dataIndex: 'jobID',
            minWidth: 100,
          },
          {
            title: 'Created On',
            dataIndex: 'createTime',
            minWidth: 100,
            customRender({ text }) {
              return parseTime(text, '{m}/{d} {h}:{i}')
            },
          },
          {
            title: 'Responsed By',
            dataIndex: 'responesBy',
            minWidth: 100,
          },
          {
            title: 'Line Stop',
            dataIndex: 'stopWs',
            minWidth: 100,
          },
          {
            title: 'Status',
            dataIndex: 'status',
            minWidth: 100,
          },
        ],
        andonItem: [],
      }
    },

    methods: {
      feedSplice(list, maxBomNum) {
        let c = [...list]
        let ret = c.splice(0, maxBomNum)
        return ret
      },
      openBomModal(item) {
        this.moreModal = true
        this.bomItems = item
      },
      isShowBomMore(obj) {
        //是否要显示更多物料
        var lengthArr = []
        for (let key in obj) {
          lengthArr.push(obj[key].length)
        }
        return Math.max.apply(null, lengthArr) > this.maxBomNum
      },
      goStaging(regionCode) {
        this.$router.push({ name: 'staging', params: { regionCode } })
      },
      showCart(str) {
      	return str ? str.slice(0,7).replace("-", "_") : ''
      },
      limitTo(str, num) {
        return str ? str.slice(num) : ''
      },
      openAndonDetailModal(event, item) {
        event.stopPropagation()
        this.sAndonModal = true
        this.andonItem = []
        this.loading = true
        andonsummaryByRegion(item.regionCode)
          .then((res) => {
            this.andonItem = res.body
          })
          .finally(() => {
            this.loading = false
          })
      },
      goKanbanPage(item) {
        if (item.startControl == 'M') {
          this.$router.push({
            name: 'workStation',
            params: { id: item.regionCode },
          })
        } else {
          this.$router.push({
            name: 'manual',
            params: { regionCode: item.regionCode },
          })
        }
      },
    },
  }
</script>
<style lang="less">
  .has-table-full-modal {
    .ant-modal-body {
      padding: 0;
    }
    .has-bom-header {
      padding-bottom: 50px;
    }
  }
</style>

<style lang="less" scoped>
  @import '~@/styles/variables.less';
  .title-no-pd {
    margin: -16px -24px;
    padding: 10px 25px 0;

    &.Green {
      background: @green;
      color: @white;
      border-color: @green;
    }
    &.Red {
      background: @danger;
      color: @white;
      border-color: @danger;
    }
    &.BorderGreen {
      background: @grayC;
      color: @white;
      border-color: @green;
    }
    &.Grey {
      background: @grayC;
      border-color: @grayC;
      color: @white;
    }
  }

  ul,
  li {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  .no-icon {
    display: none;
  }
  .supervisor-content {
    padding: 10px;
    position: relative;
  }
  .page-button {
    color: #fff;
    cursor: pointer;
    &:active {
      opacity: 0.8;
    }
  }
  .previous-page,
  .next-page {
    position: absolute;
    font-size: 40px;
    top: 50%;
    margin-top: -150px;
    left: 0;
    height: 300px;
    min-height: 30px;
    min-width: 30px;
    line-height: 24px;
    width: 50px;
    padding: 0;
    background: transparent;
    z-index: 1000;
  }

  .previous-page .in,
  .next-page .in {
    position: absolute;
    top: 50%;
    margin-top: -24px;
    background: @subMaster;
    border: 1px solid @subMaster;
    width: 48px;
    height: 48px;
    text-align: center;
    border-radius: 50%;
    padding: 0;
    transform: translateX(-70px);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s;
    i.icon {
      vertical-align: middle;
      color: @white;
    }
  }
  .on-show.previous-page,
  .on-show.next-page {
    .in {
      transform: translateX(0);
    }
  }
  .previous-page.activated,
  .next-page.activated {
    border: none;
    background-color: transparent;
  }
  .next-page {
    right: 0;
    left: initial;
    .in {
      transform: translateX(70px);
    }
  }
  .dash-row {
    padding: 0;
    justify-content: center;
    display: flex;
    .col {
      padding: 80px 0 0;
      flex: 0 0 205px;
      width: 100%;
      &.has-icon-right-hr,
      &.has-icon-left-hr {
        flex: 0 0 270px;
      }
      &.has-icon-left-hr.has-icon-right-hr {
        flex: 0 0 330px;
        .kb-list-box {
          padding: 0 30px 0 85px;
        }
      }
      &.buffer-area {
        flex: 0 0 100px;
        .andon {
          right: 10px;
        }
        &.has-icon-left-hr.has-icon-right-hr {
          flex: 0 0 140px;
        }
        .st {
          display: flex;
          align-items: center;
          justify-items: center;
        }
        .right-icon-box,
        .left-icon-box {
          font-size: 36px;
          color: #a8a8a8;
        }
      }
      &.buffer-area.has-icon-left,
      &.buffer-area.has-icon-right {
        flex: 0 0 100px;
      }
      &.buffer-area.has-icon-left.has-icon-right {
        flex: 0 0 160px;
      }
      &.buffer-area.has-icon-left.has-icon-right {
        flex: 0 0 160px;
      }
      &.buffer-area.has-icon-left.has-icon-right.has-icon-left-hr,
      &.buffer-area.has-icon-left.has-icon-right.has-icon-right-hr {
        flex: 0 0 120px;
      }
      &.fifo-area {
        flex: 0 0 68px;
      }

      &.has-icon-left-hr .left-icon-box,
      &.has-icon-right-hr .right-icon-box {
        width: 20px;
        display: block;
      }

      .andon {
        position: absolute;
        top: 18px;
        right: -15px;
        width: 15px;
        height: 10px;
        background-color: initial;
        border-bottom: 2px solid #a8a8a8;
        border-right: 2px solid #a8a8a8;

        .deng {
          &.-px {
            padding: 1px;
            i {
              margin-bottom: 1px;
            }
            i:last-child {
              margin-bottom: 0;
            }
          }
          width: 20px;
          padding: 1px;
          border: 1px solid #a8a8a8;
          border-radius: 3px;
          position: absolute;
          top: -30px;
          right: -11px;
          background: @white;
          i {
            display: block;
            height: 8px;
            width: 100%;
            background: @black2;
            margin-bottom: 1px;
          }
        }
        .deng > i:nth-child(1) {
          background: @green;
        }
        &.warning .deng {
          i {
            background: @black2;
          }
          & > i:nth-child(2) {
            background: @warning;
          }
        }
        &.danger .deng {
          i {
            background: @black2;
          }
          & > i:nth-child(3) {
            background: @danger;
          }
        }
      }
      &.warning {
        background-color: @warning;
      }
      &.danger {
        background-color: @danger;
      }
    }
    .col.has-icon-left {
      .kb-list-box {
        padding: 0 25px 0 80px;
      }
    }
    .col.has-icon-left,
    .col.has-icon-right {
      flex: 0 0 272px;
    }
    .col.has-icon-left.has-icon-right {
      flex: 0 0 320px;
      .kb-list-box {
        padding: 0 25px 0 80px;
      }
    }
  }
  .l-box {
    position: relative;
    display: flex;
    align-items: center;
    justify-items: center;
    .left-icon-box,
    .right-icon-box {
      font-size: 36px;
      color: #a8a8a8;
      flex: 0 0 60px;
      text-align: center;
    }

    .kanban {
      background: @gray-f;
      color: @white;
      padding: 5px;
      border-radius: 5px;
      min-height: 100px;
      min-width: 145px;
      //max-width: 200px;
      position: relative;
      margin: 0 auto;
      z-index: 1;
      flex: 1;
      &.default,
      &.grey {
        background: @grayC;
        h4 {
          color: @grayC;
        }
        canvas {
          opacity: 0.3;
        }
      }
      &.border-green {
        background: @green;
        .work-order {
          background: @grayC;
        }
        h4 {
          color: @grayC;
        }
        canvas {
          opacity: 1;
        }
      }
      &.danger {
        background-color: @danger;
        h4 {
          color: @danger;
        }
        canvas {
          opacity: 1;
        }
      }
      &.green {
        background-color: @green;
        h4 {
          color: @green;
        }
        canvas {
          opacity: 1;
        }
      }
      &.warning {
        background-color: @warning;
        h4 {
          color: @warning;
        }
        canvas {
          opacity: 1;
        }
      }
      .in-box {
        min-height: 60px;
        line-height: 40px;
        position: relative;
        background: -webkit-linear-gradient(top, #fff 20%, #f8f8f8 80%, #fff);
        text-align: center;
        padding: 0 10px;
      }
      h4 {
        color: @gray-f;
        font-size: 36px;
        padding: 0;
        margin: 0;
        line-height: 60px;
      }
      .work-order {
        font-size: 20px;
        font-weight: 600;
        padding: 10px 10px 5px;
        white-space: nowrap;
      }
    }
  }
  .kb-list-box {
    padding: 0 30px 0 20px;
    position: relative;
    display: flex;
    & > div {
      flex: 1;
    }
    .bom-more-btn {
      position: absolute;
      left: 10px;
      right: 50px;
      bottom: -60px;
      z-index: 11;
      text-align: center;
      color: @black4;
      background: -webkit-linear-gradient(
        top,
        rgba(255, 255, 255, 0) 10%,
        #fdfdfd
      );
      padding: 0 10px;
      border-radius: 5px;
      line-height: 30px;
      border: none;
      border-bottom: 1px solid #ccc;
      min-height: initial;
      font-size: 24px;
      &.activated {
        background: -webkit-linear-gradient(
          top,
          rgba(255, 255, 255, 0),
          #f1f1f1
        );
      }
    }
    .s-kanban-list {
      padding: 0 5px;
      flex: 1;

      li {
        border-left: 0.25rem solid @gray8;
        border-bottom: 0.125rem solid @gray8;
        position: relative;
        min-height: 50px;
        width: 38px;
        &.is-triangle:before {
          @side_length: 38px;
          @altitude: (@side_length * (sqrt(5) / 2) / 2);
          content: '';
          display: block;
          width: 0;
          height: 0;
          border-color: @green transparent;
          border-style: solid;
          border-width: 0 @altitude @side_length;
          position: absolute;
          right: -9px;
          top: 28px;
        }
        &.is-triangle.danger:before {
          border-color: @danger transparent;
        }
        &.is-triangle.warning:before {
          border-color: @warning transparent;
        }
        &.is-triangle.grey:before {
          border-color: @grayC transparent;
        }
        &.warning {
          i {
            background-color: @warning;
            color: @black8;
          }
        }
        &.danger {
          i {
            background-color: @danger;
          }
        }
        &.grey {
          i {
            background-color: @grayC;
          }
        }
        i {
          position: absolute;
          display: block;
          background: @green;
          color: @white;
          min-width: 30px;
          min-height: 30px;
          left: 7px;
          top: 34px;
          text-align: center;
          padding: 0 5px;
          line-height: 32px;
          font-size: 14px;
          font-style: normal;
        }
        &.is-triangle {
          i {
            background: none;
            left: 10px;
            padding: 0;
            font-size: 12px;
          }
        }
        &.is-circle {
          i {
            width: 36px;
            height: 36px;
            border-radius: 50%;
            line-height: 36px;
            right: -8px;
            top: 32px;
            padding: 0;
          }
        }
        &.multiple {
          span {
            position: absolute;
            display: block;
            left: 10px;
            top: 36px;
            text-align: left;
            line-height: 30px;
            min-width: 80px;
            i {
              position: static;
              display: inline-block;
              text-align: center;
              &.warning {
                background-color: @warning;
              }
              &.danger {
                background-color: @danger;
              }
            }
          }
        }
      }
    }
  }
  .reverse-icon {
    transform: rotate(180deg);
  }
  .icon-dengyuhao {
    transform: rotate(-45deg);
  }

  .big-triangle {
    position: relative;
    width: 58px;
    line-height: 64px;
    text-align: center;
    color: @white;
    font-size: 16px;
    padding-top: 20px;
    font-weight: 600;
    margin: 0 auto;
    .andon {
      right: 12px;
    }
    .staging-link {
      display: block;
      position: absolute;
      width: 61px;
      height: 60px;
      left: 0;
      top: 20px;
      z-index: 100;
    }
    .txt {
      line-height: 1;
      color: @black6;
      font-size: 15px;
      font-weight: normal;
    }
    &:before {
      @side_length: 56px;
      @altitude: (@side_length * (sqrt(5) / 2) / 2);
      content: '';
      display: block;
      width: 0;
      height: 0;
      border-width: 0 @altitude @side_length;
      border-color: @green transparent;
      border-style: solid;
      position: absolute;
      z-index: 1;
    }
    .num {
      position: relative;
      z-index: 10;
    }
    &.danger {
      color: #fff;
    }
    &.danger:before {
      border-color: @danger transparent;
    }
    &.warning:before {
      border-color: @warning transparent;
    }
  }
  :deep(.ant-table-tbody .table-striped td) {
    background-color: #fbfbfb;
  }
</style>
